import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  login: {
    currentCustomer: null,
    logged: false, //đã log thì cho xem nội dung
    error: false, //để nếu login 5 lần ko được thì block trong 5p
  },
};
const authReducer = createSlice({
  name: "authReducer",
  initialState,
  reducers: {
    loggedIn: (state, action) => {
      state.login.logged = true;
      state.login.currentCustomer = action.payload;
    },
    loggedOut: (state, action) => {
      state.login.logged = false;
      state.login.currentCustomer = null;
    },
    updateInfo: (state, action) => {
      state.login.currentCustomer.fullName = action.payload.fullName;
      state.login.currentCustomer.phone = action.payload.phone;
      state.login.currentCustomer.address = action.payload.address;
    },
    updateAccessToken: (state, action) => {
      state.login.currentCustomer.accessToken = action.payload.newAccessToken;
    },
  },
});
export const { loggedIn, loggedOut, updateInfo, updateAccessToken } =
  authReducer.actions;
export default authReducer.reducer;
